import { useEffect } from "react";
import Hero from "@/components/en/Hero";
import AboutSection from "@/components/en/AboutSection";
import DonationSection from "@/components/en/DonationSection";
import Footer from "@/components/en/Footer";

const IndexEN = () => {
  useEffect(() => {
    const title = "NeuroResearch Foundation - Neurological Disease Research";
    const description = "Foundation dedicated to neurological disease research: Chronic Pain, Alzheimer's, Parkinson's and ALS. Donate to support innovative treatment research. We support patient associations across Europe, including rare diseases in Spain and Portugal. We are delighted to support research into the ECS system and Neuro connectors.";
    
    document.title = title;
    
    const updateMeta = (selector: string, attr: string, value: string) => {
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement('meta');
        if (selector.includes('property=')) {
          el.setAttribute('property', selector.match(/property="([^"]+)"/)?.[1] || '');
        } else if (selector.includes('name=')) {
          el.setAttribute('name', selector.match(/name="([^"]+)"/)?.[1] || '');
        }
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    updateMeta('meta[name="description"]', 'content', description);
    updateMeta('meta[property="og:title"]', 'content', title);
    updateMeta('meta[property="og:description"]', 'content', description);
    updateMeta('meta[property="og:locale"]', 'content', 'en_GB');
    updateMeta('meta[property="og:type"]', 'content', 'website');
  }, []);

  return (
    <div className="min-h-screen">
      <Hero />
      <AboutSection />
      <DonationSection />
      <Footer />
    </div>
  );
};

export default IndexEN;
